import { render, staticRenderFns } from "./GradingSystem.vue?vue&type=template&id=0329989d&"
import script from "./GradingSystem.vue?vue&type=script&lang=js&"
export * from "./GradingSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports